import { createRouter, createWebHistory } from 'vue-router'
import { useClosedOnlineTestStore } from '@/store/ClosedOnlineTest'
import { useMicrositeStore } from '@/store/Microsites'

const Listing = () => import(/* webpackChunkName: "Listing" */ '@/views/Listing.vue')
const CWCOT = () => /* webpackChunkName: "mscw-cwcot" */ import('@/views/classic-world-closed-online-test/index.vue')
const CWCOT_V2 = () =>
  /* webpackChunkName: "mscw-cwcot-v2" */ import('@/views/classic-world-closed-online-test-v2/index.vue')
const FoundersPack = () => /* webpackChunkName: "mscw-founders-pack" */ import('@/views/founders-pack/index.vue')

const routes = [
  {
    path: '/',
    component: Listing,
  },
  {
    path: '/classic-world-closed-online-test',
    component: CWCOT,
    // beforeEnter: async (to, _from, next) => {
    //   const closedOnlineTestStore = useClosedOnlineTestStore()
    //   const micrositeStore = useMicrositeStore()

    //   micrositeStore.loading = true

    //   if (closedOnlineTestStore.isLoggedIn === null) {
    //     // closedOnlineTestStore.isLoggedIn === null make sure checkUserIsAllowed is called only once,
    //     //  without it, when there is `cwcotsignup` query param,
    //     // this function will be called multiple times causing multiple API calls
    //     try {
    //       await closedOnlineTestStore.checkUserIsAllowed()
    //     } catch {
    //       // Intentionally ignore errors when checking user access
    //     }
    //   }

    //   try {
    //     if (to.query.cwcotsignup) {
    //       // Remove the query parameter
    //       const query = { ...to.query }
    //       delete query.cwcotsignup

    //       if (!closedOnlineTestStore.isLoggedIn) {
    //         // should be logged in to sign up/subscribe
    //         closedOnlineTestStore.dialog.type = 'error'
    //         closedOnlineTestStore.dialog.show = true
    //       } else if (!closedOnlineTestStore.isAllowedCountry) {
    //         closedOnlineTestStore.dialog.type = 'not-eligible'
    //         closedOnlineTestStore.dialog.show = true
    //         closedOnlineTestStore.hideBtnActions = true
    //       } else if (!closedOnlineTestStore.isSignedUp) {
    //         closedOnlineTestStore.dialog.show = true
    //       }

    //       micrositeStore.loading = false

    //       next({
    //         ...to,
    //         query: query,
    //         replace: true,
    //       })

    //       return
    //     }
    //   } catch {
    //     // Intentionally ignore errors when processing query parameters
    //   }

    //   micrositeStore.loading = false
    //   next()
    // },
  },

  {
    path: '/classic-world-closed-online-test-2',
    component: CWCOT_V2,
    beforeEnter: async (to, _from, next) => {
      const closedOnlineTestStore = useClosedOnlineTestStore()
      const micrositeStore = useMicrositeStore()

      micrositeStore.loading = true

      if (closedOnlineTestStore.isLoggedIn === null) {
        // closedOnlineTestStore.isLoggedIn === null make sure checkUserIsAllowed is called only once,
        //  without it, when there is `cwcotsignup` query param,
        // this function will be called multiple times causing multiple API calls
        try {
          await closedOnlineTestStore.checkUserIsAllowed()
        } catch {
          // Intentionally ignore errors when checking user access
        }
      }

      try {
        if (to.query.cwcotsignup) {
          // Remove the query parameter
          const query = { ...to.query }
          delete query.cwcotsignup

          if (!closedOnlineTestStore.isLoggedIn) {
            // should be logged in to sign up/subscribe
            closedOnlineTestStore.dialog.type = 'error'
            closedOnlineTestStore.dialog.show = true
          } else if (!closedOnlineTestStore.isAllowedCountry) {
            closedOnlineTestStore.dialog.type = 'not-eligible'
            closedOnlineTestStore.dialog.show = true
            closedOnlineTestStore.hideBtnActions = true
          } else if (!closedOnlineTestStore.isSignedUp) {
            closedOnlineTestStore.dialog.show = true
          }

          micrositeStore.loading = false

          next({
            ...to,
            query: query,
            replace: true,
          })

          return
        }
      } catch {
        // Intentionally ignore errors when processing query parameters
      }

      micrositeStore.loading = false
      next()
    },
  },
  {
    path: '/pre-launch-sales',
    component: FoundersPack,
  },
]

const router = createRouter({
  history: createWebHistory('/mscw'),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

export { router, routes }
